import { schoolApi } from '../../../services';
import {
	createStatsQueryHook,
	createChartQueryHook,
	type StatsQueryParams,
	type ChartQueryParams,
} from '../../../hooks';

const THPT_FILTER_KEYS = ['query', 'years', 'maKhoa', 'maNganh', 'maTinh'] as const;

export interface UseTHPTQueryParams extends StatsQueryParams {
	maTinhMoi?: string[];
	hasCodeNameChange?: boolean;
	top149?: boolean;
	/** true khi maTinh/maTinhMoi đến từ CÙNG một ô tìm kiếm tự do khớp cả hai
	 * không gian mã tỉnh — backend phải ghép OR thay vì AND. */
	provinceQueryOr?: boolean;
}

export type UseTHPTChartParams = ChartQueryParams;

/**
 * Factory-based THPT stats hook with entity-specific extra params.
 * The extra params (maTinhMoi, hasCodeNameChange, top149, provinceQueryOr) are
 * forwarded via the factory's extraParams mechanism.
 */
const _useTHPTStatsQuery = createStatsQueryHook({
	entityKey: 'thpt',
	apiFn: (params) => schoolApi.getSchoolStatsBySearchParams(params),
	filterKeys: THPT_FILTER_KEYS,
});

function toTHPTStatsParams(params: UseTHPTQueryParams): StatsQueryParams {
	const { maTinhMoi, hasCodeNameChange, top149, provinceQueryOr, ...baseParams } = params;

	const extraParams: Record<string, unknown> = {};
	if (maTinhMoi && maTinhMoi.length > 0) extraParams.maTinhMoi = maTinhMoi;
	if (hasCodeNameChange !== undefined) extraParams.hasCodeNameChange = hasCodeNameChange;
	if (top149 !== undefined) extraParams.top149 = top149;
	if (provinceQueryOr) extraParams.provinceQueryOr = provinceQueryOr;

	return {
		...baseParams,
		extraParams: Object.keys(extraParams).length > 0 ? extraParams : undefined,
	};
}

export function useTHPTQuery(params: UseTHPTQueryParams) {
	return _useTHPTStatsQuery(toTHPTStatsParams(params));
}

export function buildTHPTExportParams(params: UseTHPTQueryParams): URLSearchParams {
	return _useTHPTStatsQuery.buildExportParams(toTHPTStatsParams(params));
}

export const useTHPTChartQuery = createChartQueryHook({
	entityKey: 'thpt',
	apiFn: (params) => schoolApi.getNivoLineChartData(params),
	filterKeys: THPT_FILTER_KEYS,
});
